/**
 * useDataAgentDetails Hook
 *
 * React Query hook for fetching a single data agent.
 */

import { useQuery } from '@tanstack/react-query';
import { dataAgentService } from '../../../api/data-agent.service';
import type { DataAgent } from '../../../types/data-agent.types';

export const DATA_AGENT_DETAILS_QUERY_KEY = 'dataAgentDetails';

export function useDataAgentDetails(tenantId: string, dataAgentId: string) {
  return useQuery<DataAgent, Error>({
    queryKey: [DATA_AGENT_DETAILS_QUERY_KEY, tenantId, dataAgentId],
    queryFn: () => dataAgentService.getDataAgent(tenantId, dataAgentId),
    enabled: !!tenantId && !!dataAgentId,
    staleTime: 30000,
  });
}
